/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';

import { Grid, makeStyles, Typography } from '@material-ui/core';

import LoadingButton from '../common/LoadingButton';

const useStyles = makeStyles(() => {
  return {
    sectionHeader: {
      color: '#172B4D',
      fontSize: '18px',
      fontWeight: 'bold',
      marginBottom: '1rem',
    },
    sectionText: {
      color: '#999999',
      fontSize: '12px',
      marginTop: '1rem',
    },
    sectionTextArchived: {
      color: '#999999',
      fontSize: '12px',
      marginTop: '0px',
    },
    textWarning: {
      color: '#B12A2A',
    },
  };
});

export default ({ onCaseAction, auth, isArchiving$ }) => {
  const classes = useStyles();

  return (
    <Grid container style={{ textAlign: 'left' }}>
      <Grid item>
        <Grid container>
          <Grid item xs={12}>
            <Typography className={classes.sectionHeader}>Unarchive Case</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography className={classes.sectionTextArchived}>By clicking the below button you will unarchive this case.</Typography>
          </Grid>
          <Grid item xs={12} style={{ marginTop: '1rem' }}>
            <LoadingButton loading$={isArchiving$} disabled={auth?.role !== 'super-admin'} variant="outlined" size="large" onClick={() => onCaseAction('unarchive')}>
              Unarchive
            </LoadingButton>
            {auth?.role !== 'super-admin' && <Typography className={`${classes.sectionText} ${classes.textWarning}`}>Only super-admin allowed to unarchive case</Typography>}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
